import type { IOrderApplication } from "@/data/model/OrderApplication";
import { Misc } from "@/data/util/Misc";

export class PushNotificationsHelper {
    public static isPushNotificationsEnabled(useCase?: IOrderApplication): boolean {
        const isIosDevice = Misc.isIosDevice();

        if (useCase?.enableNotifications === true) {
            if (isIosDevice === true) {
                return useCase?.enablePushNotificationsOnIos === true;
            } else {
                return useCase?.enablePushNotificationsOnAndroid === true;
            }
        }

        return false;
    }

    public static IsNotificationAvailable() {
        return "Notification" in window;
    }

    //TODO: To improve
    public static IsNotificationGranted() {
        return Notification.permission === "granted";
    }
}
